import PropTypes from 'prop-types';
import { Progress } from 'react-sweet-progress';
import ProgressWrapper from './ProgressWrapper';
import { Icon } from '../icons';
import { colors } from '../../styles/theme';

const normalizePercent = (percent) => {
  const roundedPercent = Math.round(percent);
  const min = 0;
  const max = 100;
  return Math.min(Math.max(roundedPercent, min), max);
};

const ProgressBar = (props) => {
  const { percent, status } = props;
  const normalizedPercent = normalizePercent(percent);

  const errorIcon = <Icon type="x" color={colors.red.primary} />;
  const successIcon = <Icon type="checkmark" color={colors.green.primary} />;
  const theme = {
    error: {
      symbol: errorIcon,
      color: colors.red.primary,
    },
    default: {
      symbol: `${normalizedPercent}%`,
      color: colors.blue.secondaryDark,
    },
    active: {
      symbol: `${normalizedPercent}%`,
      color: colors.blue.secondaryDark,
    },
    success: {
      symbol: successIcon,
      color: colors.green.primary,
    },
  };

  return (
    <ProgressWrapper>
      <Progress theme={theme} percent={normalizedPercent} status={status} />
    </ProgressWrapper>
  );
};

ProgressBar.propTypes = {
  status: PropTypes.oneOf(['error', 'default', 'active', 'success']),
  percent: PropTypes.number,
};

ProgressBar.defaultProps = {
  status: 'default',
  percent: 0,
};

export { ProgressBar };
